import React from "react";
import { Card } from "react-bootstrap";
import "./ExerciseItem.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrash, faDumbbell } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "antd";
import classNames from "classnames";
import { Exercise } from "../../types/Entities";
import VideoThumb from "../../common/VideoThumb";
import { isVideoSrc } from "../../utils/mediaKind";

type Props = {
  exercise: Exercise;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onView?: React.MouseEventHandler<HTMLButtonElement>;
  onEdit?: React.MouseEventHandler<HTMLButtonElement>;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
};

function ExerciseItem({ exercise, onEdit, onDelete }: Props) {
  const hasPhoto = Boolean(exercise.signedUrl);

  return (
    <Card className="app-list-item exercise-card">
      <div className="exercise-card-bg">
        {hasPhoto && isVideoSrc(exercise.signedUrl) ? (
          // Video media plays inline (muted/looped) so the card preview moves.
          <VideoThumb
            src={exercise.signedUrl!}
            radius={0}
            style={{ width: "100%", height: "100%" }}
          />
        ) : (
          // GIFs animate on their own through <img>; static images render still.
          <img
            src={exercise.signedUrl || require("../../assets/img/weight.png")}
            className={classNames("exercise-card-img", {
              "exercise-card-img--placeholder": !hasPhoto,
            })}
            alt={exercise.name}
            loading="lazy"
          />
        )}
        <div className="exercise-card-overlay" />
      </div>

      <div className="exercise-card-body">
        <div className="exercise-card-top">
          {exercise.motorPattern?.motorPattern && (
            <span className="ex-chip ex-chip--pattern">
              {exercise.motorPattern.motorPattern}
            </span>
          )}
        </div>

        <div className="exercise-card-bottom">
          <span
            className={classNames("ex-chip", "ex-chip--muscle", {
              "ex-chip--muted": !exercise.muscleGroup,
            })}
          >
            <FontAwesomeIcon icon={faDumbbell} className="ex-chip-ic" />
            {exercise.muscleGroup?.muscleGroup || "Nessun gruppo"}
          </span>

          <h5 className="exercise-card-title" title={exercise.name}>
            {exercise.name}
          </h5>

          {exercise.description && (
            <Tooltip title={exercise.description} mouseEnterDelay={0.3}>
              <p className="exercise-card-desc">{exercise.description}</p>
            </Tooltip>
          )}

          <div className="exercise-card-actions">
            <Tooltip title="Modifica esercizio" mouseEnterDelay={0.3}>
              <button
                type="button"
                className="ex-action ex-action--edit"
                onClick={onEdit}
                aria-label="Modifica esercizio"
              >
                <FontAwesomeIcon icon={faPencil} />
              </button>
            </Tooltip>
            <Tooltip title="Cancella esercizio" mouseEnterDelay={0.3}>
              <button
                type="button"
                className="ex-action ex-action--delete"
                onClick={onDelete}
                aria-label="Cancella esercizio"
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </Tooltip>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default ExerciseItem;
